const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: "/impressum",
    exact: true,
    component: "Impressum",
  },
];

export default routes;
